import ReportDetailsModel   from 'ReportDetailsModel';

//Utils & libraries
import util from 'util/Util';
import _ from 'lodash';
import constants from 'Constants.js';
import { Model } from 'backbone';

//Services
import restService from 'RestService';
import configService from 'ConfigService';

//Modals
import PlayFormModal from 'common-views/PlayFormModal.js';




class ReportService {

    constructor() {
        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });
    }

    createNewModel(reportId, reportDetailsResult, groupType, parentId, isPrivate) {

        const reportDetailsData = reportDetailsResult.RESULT.RESPONSE.PrivateReportDetails;
        const reportDetailsModel = new ReportDetailsModel();

        let permissionList = [];
        let dependenceList = [];

        // Adding Permissions to an array if any
        if (reportDetailsData['PermissionsXML']) {
            permissionList = reportDetailsData['PermissionsXML'].Permissions.User instanceof Array
                ? reportDetailsData['PermissionsXML'].Permissions.User
                : [reportDetailsData['PermissionsXML'].Permissions.User];
        }
        // Adding Dependences to an array if any
        if (reportDetailsData['Dependencies']) {
            let tmpDependenceList = reportDetailsData['Dependencies'].Dependency instanceof Array
                ? reportDetailsData['Dependencies'].Dependency
                : [reportDetailsData['Dependencies'].Dependency];
            dependenceList = _.sortBy(tmpDependenceList,['@type', '@name']);
        }        

        // PF-2307
        reportDetailsModel.set('ownerId', reportDetailsData.OwnerId);
        reportDetailsModel.set('ownerName', reportDetailsData.OwnerName);

        reportDetailsModel.set('reportName', reportDetailsData.Name);
        reportDetailsModel.set('currentReportName', reportDetailsData.Name);
        reportDetailsModel.set('dateCreated', util.getFormattedDate(reportDetailsData.CreatedDate));
        reportDetailsModel.set('lastUpdate', util.getFormattedDate(reportDetailsData.LastUpdate));
        reportDetailsModel.set('lastUpdateUTC', util.formatUTC(reportDetailsData.LastUpdate));
        reportDetailsModel.set('latestVersion', reportDetailsData.Version);
        reportDetailsModel.set('viewedBy', permissionList);
        reportDetailsModel.set('deployedVersion', reportDetailsData.DeployVersion);
        reportDetailsModel.set('isActive', reportDetailsData.IsActive === 'True' ? true : false);
        reportDetailsModel.set('currentIsActive', reportDetailsData.IsActive === 'True' ? true : false);
        reportDetailsModel.set('version', 'latest');
        reportDetailsModel.set('reportId', reportId);
        reportDetailsModel.set('parentId', parentId);
        reportDetailsModel.set('versionList', reportDetailsData.VersionList.Version);

        reportDetailsModel.set('permissionList', _.cloneDeep(permissionList));
        reportDetailsModel.set('currentPermissionList', _.cloneDeep(permissionList));

        reportDetailsModel.set('dependenceList', Object.assign([],dependenceList));

        reportDetailsModel.set('LinkId', reportDetailsData.LinkId);
        reportDetailsModel.set('Width', reportDetailsData.Width);
        reportDetailsModel.set('Height', reportDetailsData.Height);
        reportDetailsModel.set('IsDeployed', reportDetailsData.IsDeployed);
        reportDetailsModel.set('GroupId', reportDetailsData.GroupId);
        reportDetailsModel.set('IsPrivate', util.isTrue(reportDetailsData.IsPrivate));
        reportDetailsModel.set('groupType', groupType);
        reportDetailsModel.set('hasChanges', false);
        reportDetailsModel.set('responsive', reportDetailsData.IsResponsive);
        reportDetailsModel.set('containsMobileErrors', reportDetailsData.ContainsMobileErrors);
        reportDetailsModel.set('LastRecoveryUpdateDate', reportDetailsData.LastRecoveryUpdateDate);

        // Configure Title and Breadcrumbs
        const breadcrumbs = [
            {name: 'Home', route: '#reports'},
            {name: 'Reports', route: '#reports'}
        ];

        reportDetailsModel.set('dashboardTitle', reportDetailsModel.get('IsPrivate') ? `Report - ${reportDetailsData.Name}` : `Shared Report - ${reportDetailsData.Name}`);
        
         reportDetailsModel.set('breadcrumbs', breadcrumbs);
        
        return reportDetailsModel;
    }
    
    viewReport(id) {
        const instanceUrl = restService.getViewReportLinkUrl(id);
        const attributes = {url: instanceUrl, id: id };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {});
    }

}

const reportService = new ReportService();
export default reportService;